import { CrossFrameUtils } from '@utils/CrossFrameUtils';

import _ from 'lodash';

export class DeviceDetails {
    public static async getDeviceDetails() {
        try {
            const result = await CrossFrameUtils.sendMessageToOtherFrame({
                frame: window,
                message: {
                    method: 'getDeviceDetails',
                },
            });
            if (typeof result === 'object') {
                console.debug('Found device details ', JSON.stringify(result));
                DeviceDetails.deviceDetails = _.cloneDeep(result);
                return DeviceDetails.deviceDetails;
            } else {
                const errorMsg = 'Response received from CrossFrameUtils is not an object.';
                console.error(`${errorMsg}\nReceived: ${result}`);
                throw new Error(errorMsg);
            }
        } catch (exception) {
            console.warn('Device details not found.');
            DeviceDetails.deviceDetails = {};
            return DeviceDetails.deviceDetails;
        }
    }

    private static deviceDetails: object;
}
